import { Component, OnInit } from '@angular/core';
import { Objective, ObjectiveTask } from '../../models/objectives';
import { ObjectivesService } from '../../services/objectives.service';

import { MyTaskRowComponent } from '../../components/my-task-row/my-task-row.component';

@Component({
    selector: 'app-my-tasks',
    templateUrl: './my-tasks.component.html',
    styleUrls: ['./my-tasks.component.css'],
    imports: [MyTaskRowComponent]
})
export class MyTasksComponent implements OnInit {

  Tasks: ObjectiveTask[];

  constructor(
    private objectiveSrv: ObjectivesService
  ) { }

  ngOnInit(): void {
    this.objectiveSrv.getTasksForUser('').subscribe(objs=>{
      this.Tasks = objs as ObjectiveTask[];
    });
  }

}
